import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBaseService } from './http-base.service';
import { CountryCreateDto, CountryListDto } from '../dtos/country.types';

@Injectable({
    providedIn: 'root'
})
export class CountryService extends HttpBaseService {
    private readonly baseEndpoint = 'api/Countries';

    /**
     * Get all countries
     */
    getAllCountries(): Observable<CountryListDto[]> {
        return this.get<CountryListDto[]>(this.baseEndpoint);
    }

    /**
     * Get country by ID
     */
    getCountryById(countryId: string): Observable<CountryListDto> {
        return this.get<CountryListDto>(`${this.baseEndpoint}/${countryId}`);
    }

    /**
     * Create a new country
     * @returns Observable containing the created country's ID
     */
    createCountry(country: CountryCreateDto): Observable<{ id: string }> {
        return this.post<{ id: string }>(this.baseEndpoint, country);
    }

    /**
     * Delete a country
     */
    deleteCountry(countryId: string): Observable<void> {
        return this.delete<void>(`${this.baseEndpoint}/${countryId}`);
    }
}